/**
 * Prevents event propagation
 */
export const preventPropagation = (e: React.SyntheticEvent): void => {
  e.stopPropagation();
  // For certain cases, prevent default browser behavior too
  if (e.target === e.currentTarget) {
    e.preventDefault();
  }
};

/**
 * Creates a debounced function that delays invoking func until after wait milliseconds
 */
export const debounce = <T extends (...args: any[]) => any>(
  func: T,
  wait: number,
): ((...args: Parameters<T>) => void) => {
  let timeout: NodeJS.Timeout | null = null;

  return (...args: Parameters<T>) => {
    if (timeout) clearTimeout(timeout);

    timeout = setTimeout(() => {
      func(...args);
    }, wait);
  };
};

/**
 * Checks if mouse movement is significant
 */
export const isSignificantMouseMovement = (e: MouseEvent): boolean => {
  return e.movementX !== 0 || e.movementY !== 0;
};
